import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ASSETS, REALTOR } from "../lib/brand";
import { ANIMATION } from "../lib/constants";

export default function CoverPage({ readerName, onStart }) {
    return (
        <div className="relative book-page bg-navy overflow-hidden">
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `url(${ASSETS.coverHero})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-navy/85 via-navy/40 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-b from-navy/60 via-transparent to-navy/70" />

            <div className="relative z-10 max-w-6xl mx-auto h-full px-6 sm:px-10 lg:px-16 py-16 flex flex-col justify-between min-h-screen">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-cream/80"
                >
                    <div className="eyebrow text-coral">2026 Edition</div>
                    <div className="mt-2 font-sans text-xs tracking-[0.3em] uppercase text-cream/60">
                        Confidential Relocation Intelligence Report
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: ANIMATION.COVER_FADE_OFFSET_PX }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.2 }}
                    className="text-cream"
                >
                    <h1 className="serif-display text-6xl sm:text-7xl md:text-8xl lg:text-9xl">
                        Moving<br/>to Florida.
                    </h1>
                    <div className="mt-8 h-px w-24 bg-gold" />
                    <p className="mt-8 max-w-2xl font-serif italic text-2xl sm:text-3xl text-cream/90 leading-snug">
                        Your complete guide to the <span className="text-gold not-italic font-light">Emerald Coast</span>.
                    </p>
                    <p className="mt-6 max-w-xl text-cream/70 leading-relaxed">
                        A hyperlocal comparison of six premier communities: Fort Walton Beach, Destin, Niceville, Navarre, Crestview, and Freeport.
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8"
                >
                    <div className="text-cream/80">
                        {readerName && (
                            <>
                                <div className="eyebrow text-coral">Prepared exclusively for</div>
                                <div className="serif-display text-3xl sm:text-4xl text-cream mt-1">{readerName}</div>
                            </>
                        )}
                        <div className="mt-4 text-xs tracking-[0.22em] uppercase text-cream/60">
                            By {REALTOR.name} · REALTOR® + Loan Originator
                        </div>
                    </div>

                    <button
                        onClick={onStart}
                        data-testid="cover-start-btn"
                        className="group inline-flex items-center justify-center gap-3 bg-cream text-navy py-4 px-8 rounded-sm font-sans text-xs font-semibold tracking-[0.22em] uppercase transition-all duration-300 hover:bg-gold hover:-translate-y-0.5"
                    >
                        Begin Reading
                        <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                    </button>
                </motion.div>
            </div>
        </div>
    );
}
